import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { GAPageTracker } from '../Components/observability/GAPageTracker.js';
import Splash from '../Components/layout/Splash/index.js';
import PushNotificationsInitializer from '@/Components/features/PushNotifications/PushNotificationsInitializer.js';

/**
 * Layout root que envolve todas as rotas.
 * O <Suspense> aqui cobre todos os componentes lazy carregados pelo AppRouter,
 * exibindo o Splash enquanto o chunk da página está sendo baixado.
 * Fica montado uma única vez durante toda a sessão (não remonta entre navegações),
 * por isso o PushNotificationsInitializer vive aqui e não numa página específica.
 */
export const RootLayout = () => {
  return (
    <>
      <GAPageTracker />
      <PushNotificationsInitializer />
      <Suspense fallback={<Splash />}>
        <Outlet />
      </Suspense>
    </>
  );
};
